// This is taken from PHP side see constants.inc.php
export enum ResourceType {
  DEVIATION = 1,
  NEWS = 2,
  SOFTWARE = 3,
  USER = 4,
  JOURNAL = 5,
  POLL = 6,
  EVENT = 7,
  HELP = 9,
  PROJECT_MANAGER = 10,
  REPORT = 11,
  CALENDAR = 12,
  PRINTADMIN = 13,
  POLL_BLOG = 14,
  PROJECT_MAIN = 15,
  PROJECT_SUMMIT = 16,
  SUMMIT_MANAGER = 17,
  FORUM = 18,
  USERFORUM = 19,
  GALLERY = 20,
  COLLECTION = 21,
  CHECKOUT = 22,
  COMMENT = 24,
  MESSAGEBOX = 25,
  NOTE = 26,
  RAP = 27,
  HELP_NOTE = 28,
  MODULE = 29,
  CRITIQUE = 30,
  GROUP = 31,
  SHOPITEM = 32,
  SKIN = 33,
  PRINT = 34,
  WORKFLOW = 35,
  GROUP_ROLE = 37,
  DEVMEET = 38,
  THREADNOTE = 39,
  SHOP = 40,
  MODULE_TICKETTRACKER = 44,
  MODULE_CONVERSATION = 46,
  MODULE_BULLETIN = 47,
  ORDER = 48,
  POINTS_TRANSACTION = 50,
  STACK_DEVWATCH = 51,
  STACK_COMMENTS = 52,
  BADGE = 53,
  // STASH = 59,    // Deprecated backend-side
  MODULE_ADMINSTATS = 60,
  USERPROFITS = 62,
  USER_RENAME_HISTORY = 63,
  COMMISSION = 66,
  ORDERED_DEVIATION_FOLDER = 67,
  STACK_MENTIONS = 68,
  STATUS = 69,
  TODAY = 70,
  DISCOVERYTAG = 71,
  DAILYDEVIATION = 72,
  HOT_TOPIC = 75,
  BIRTHDAY = 76,
  MODERATION_MESSAGE = 77,
  TOPIC = 78,
  STATUS_DEVIATION = 81,
  TIER = 82,
  STASH_FOLDER = 89,
}
